import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import {
    getFeverLoginUrl,
    getEnterpriseLoginUrl,
    getRedirectUrlFromLoginServerToPromoOrUgc
} from 'client/utils/login';
import { loginTypesForApi } from 'config/loginTypes';

export default function useLoginUrl({ loginType, additionalQsObj = {} }) {
    const { promoUUID, promoId } = useParams();
    const partner = useSelector(s => s.partner);
    const sponsor = useSelector(s => s.sponsor);

    const { uuid: sponsorUUID } = sponsor;

    const redirectUrl = getRedirectUrlFromLoginServerToPromoOrUgc({
        promoUUID,
        promoId
    });

    switch (loginType) {
        case loginTypesForApi.ENTERPRISE:
            return getEnterpriseLoginUrl({
                partner,
                sponsor,
                promoId,
                redirectUrl,
                appendQsObj: additionalQsObj
            });
        case loginTypesForApi.FACEBOOK:
        case loginTypesForApi.LINE:
            return getFeverLoginUrl({
                loginType,
                sponsorUUID,
                redirectUrl,
                appendQsObj: additionalQsObj
            });
        default:
            return '';
    }
}
